import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service'
import { ObservablesService } from '../observables.service'
@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
  preferencesForm:FormGroup;
  loggedUserInfo:any=[]
  editStatus:boolean=false
  showPopupStatus:boolean=false
  editId:any=''
  constructor(private fb:FormBuilder,private api:ApiService,private observables:ObservablesService) { }

  ngOnInit() {
    this.createForm()
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log('logged user info=',res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getPreferences()
      }else{
        this.api.logOut()
      }
    })
  }

  getPreferences(){
    this.api.send("findDb",{
      table:"preferences",
      conditions:[{"business_id":this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        this.editStatus = true;
        this.editId=res.data[0].id
        this.patchForm(res.data[0])
      }else{
        this.editStatus = false;
        this.preferencesForm.patchValue({business_id:this.loggedUserInfo.business_id})
      }
    })
  }

  patchForm(value){
    this.preferencesForm.patchValue({
      business_id:this.loggedUserInfo.business_id,
      invoice_title:value.invoice_title,
      slip_title:value.slip_title,
      item_name:value.item_name,
      unit_variable_1:value.unit_variable_1,
      unit_variable_1_status:value.unit_variable_1_status,
      unit_variable_2:value.unit_variable_2,
      unit_variable_2_status:value.unit_variable_2_status,
      unit_variable_3: value.unit_variable_3,
      unit_variable_3_status: value.unit_variable_3_status,
      item_unit_col_name:value.item_unit_col_name,
      item_unit_col_name_status:value.item_unit_col_name_status,
      unit:value.unit,
      unit_status:value.unit_status,
      tax: value.tax,
      tax_status: value.tax_status,
      unit_price:value.unit_price,
      unit_price_status:value.unit_price_status,
      discount:value.discount,
      discount_status:value.discount_status,
      autho_signatory:value.autho_signatory,
      autho_signatory_status:value.autho_signatory_status,
      receiver:value.receiver,
      receiver_status:value.receiver_status,
      grid_view_status:value.grid_view_status,
      font_size_status:value.font_size_status,
      slip_copy_status:value.slip_copy_status
    });
  }

  showPrintSettings(){
    this.showPopupStatus = true;
  }

  closeModel(){
    this.showPopupStatus = false;
  }

  createForm(){
    this.preferencesForm = this.fb.group({
      business_id:[this.loggedUserInfo.business_id, Validators.required],
      invoice_title:['INVOICE', Validators.required],
      slip_title:['DELIVERY CHALLAN', Validators.required],
      item_name:["Particulars", Validators.required],
      unit_variable_1:["Column1", Validators.required],
      unit_variable_1_status:[true],
      unit_variable_2:["Column2", Validators.required],
      unit_variable_2_status:[true],
      unit_variable_3: ["Column3", Validators.required],
      unit_variable_3_status: [true],
      item_unit_col_name:["Unit", Validators.required],
      item_unit_col_name_status:[true],
      unit:["Quantity", Validators.required],
      unit_status:[true],
      tax: ["GST", Validators.required],
      tax_status: [true],
      unit_price:["Rate", Validators.required],
      unit_price_status:[true],
      discount:["Dis", Validators.required],
      discount_status:[true],
      autho_signatory:["Proprietor", Validators.required],
      autho_signatory_status:[true],
      receiver:["Receiver Sign", Validators.required],
      receiver_status:[true],
      grid_view_status:[true],
      font_size_status:[false],
      slip_copy_status:[true]
    });
  }

  submit(value){
    if(this.editStatus){
      this.api.send("updateDb",{
        table:"preferences",
        data:{
          business_id:this.loggedUserInfo.business_id,
          invoice_title:value.invoice_title,
          slip_title:value.slip_title,
          item_name:value.item_name,
          unit_variable_1:value.unit_variable_1,
          unit_variable_1_status:value.unit_variable_1_status?1:0,
          unit_variable_2:value.unit_variable_2,
          unit_variable_2_status:value.unit_variable_2_status?1:0,
          unit_variable_3: value.unit_variable_3,
          unit_variable_3_status: value.unit_variable_3_status?1:0,
          item_unit_col_name:value.item_unit_col_name,
          item_unit_col_name_status:value.item_unit_col_name_status?1:0,
          unit:value.unit,
          unit_status:value.unit_status?1:0,
          tax: value.tax,
          tax_status: value.tax_status?1:0,
          unit_price:value.unit_price,
          unit_price_status:value.unit_price_status?1:0,
          discount:value.discount,
          discount_status:value.discount_status?1:0,
          autho_signatory:value.autho_signatory,
          autho_signatory_status:value.autho_signatory_status?1:0,
          receiver:value.receiver,
          receiver_status:value.receiver_status?1:0,
          grid_view_status:value.grid_view_status?1:0,
          font_size_status:value.font_size_status?1:0,
          slip_copy_status:value.slip_copy_status?1:0
        },
        conditions:[{business_id:this.loggedUserInfo.business_id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0, message:"Preferences Saved"})
        }else{
          this.observables.showToastMessage({type:1, message:"Preferences Not Saved"})

        }
      })
    }else{

      this.api.send("insertDb",{
        table:"preferences",
        data:{
          business_id:this.loggedUserInfo.business_id,
          invoice_title:value.invoice_title,
          slip_title:value.slip_title,
          item_name:value.item_name,
          unit_variable_1:value.unit_variable_1,
          unit_variable_1_status:value.unit_variable_1_status?1:0,
          unit_variable_2:value.unit_variable_2,
          unit_variable_2_status:value.unit_variable_2_status?1:0,
          unit_variable_3: value.unit_variable_3,
          unit_variable_3_status: value.unit_variable_3_status?1:0,
          item_unit_col_name:value.item_unit_col_name,
          item_unit_col_name_status:value.item_unit_col_name_status?1:0,
          unit:value.unit,
          unit_status:value.unit_status?1:0,
          tax: value.tax,
          tax_status: value.tax_status?1:0,
          unit_price:value.unit_price,
          unit_price_status:value.unit_price_status?1:0,
          discount:value.discount,
          discount_status:value.discount_status?1:0,
          autho_signatory:value.autho_signatory,
          autho_signatory_status:value.autho_signatory_status?1:0,
          receiver:value.receiver,
          receiver_status:value.receiver_status?1:0,
          grid_view_status:value.grid_view_status?1:0,
          font_size_status:value.font_size_status?1:0,
          slip_copy_status:value.slip_copy_status?1:0
        }
      }).then((res:any)=>{

        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0, message:"Preferences Saved"})
        }else{
          this.observables.showToastMessage({type:1, message:"Preferences Not Saved"})

        }
      })
    }
  }




}
